module.exports = __webpack_public_path__ + "img/none-item.15f676af.svg";